<ng-container *ngIf="model">
<div class="modal-header header">
  <h5 class="modal-title w-100" [translate]="model.title"></h5>
  <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body pt-0 lite-modal m-2">
    <div class="d-flex justify-content-between align-items-center mt-2">
        <div class="d-flex">
            <img *ngIf="model.image" src="assets/images/checklists/{{model.image}}.svg" class="mr-1 logo" width="25" height="30">
            <h3>{{model.label}}</h3>
        </div>
        <chapps-icon-label [icon]="'fa-info-circle'"
            [tooltip]="model.tooltip"
            [tooltipPlacement]="'right'">
        </chapps-icon-label>
    </div>
    <form *ngIf="formGroup" [formGroup]="formGroup">
        <div class="mt-2" *ngIf="labelFormControl">
            <chapps-text-input
              [placeholder]="model.placeholder"
              [control]="labelFormControl">
            </chapps-text-input>
        </div>
    </form>
</div>
<div class="modal-footer justify-content-end">
  <chapps-secondary-button
      [loading]="isSavingChanges"
      [label]="Localization.Save"
      [small]="true"
      (clicked)="onSubmit()">
  </chapps-secondary-button>
</div>
</ng-container>
